<template>
  <drag-dialog
    :visible.sync="visible"
    title="检测依据详情"
    width="600px"
    height="400px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <el-form v-loading="detailLoading" ref="editForm" label-width="120px" disabled>
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="标准号">
            <el-input v-model="editForm.basisCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测依据名称">
            <el-input type="textarea" v-model="editForm.basisName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="关联文件">
            <el-link v-if="editForm.fileId" type="primary" :underline="false" :href="$imgUrl + editForm.filePath" target="_blank">
              {{ editForm.fileName }}
            </el-link>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getBasis } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {}
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;
      try {
        const { data } = await getBasis({ id: this.activeId });
        this.editForm = {
          id: data.id,
          basisCode: data.basisCode,
          basisName: data.basisName,
          fileName: data.fileName ?? '',
          filePath: data.filePath ?? '',
          fileId: data.fileId ?? ''
        };
      } finally {
        this.detailLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
